import {
  Box,
  Collapse,
  Container,
  Flex,
  Grid,
  GridItem,
  Heading,
  Image,
  Text,
} from "@chakra-ui/react";
import AboutBg from "../img/about-bg.jpg";
import LeadershipBg from "../img/leadership-bg.png";
import Dan from "../img/Dan-Bryan.jpg";
import Rob from "../img/Rob-Sauer.png";
import Melanie from "../img/Melanie-Crozier.jpg";
import Mark from "../img/Mark-Kearns.png";
import Daniel from "../img/Daniel-Turley.jpg";
import Ada from "../img/Ada-Edwards.png";
import React, { useState } from "react";
import Perspective from "../components/Perspective";
import {absoluteUrl} from "../components/Utils";
import { CloseIcon } from "../components/Icons";
import {Helmet} from "react-helmet";

const LeadersData = [
  {
    name: "Daniel Turley",
    img: Daniel,
    title: "Managing Director Business Development",
    bio: <>
      <p>Daniel Turley is Managing Director, OM Business Development at Welltower Inc. In this role, he is responsible for the development of the investment strategy for the Outpatient Medical division, building and maintaining strategic relationships, and tailoring flexible deal structures and a full spectrum of capital stack solutions to our partners in health and wellness real estate. Mr. Turley joined the Welltower in January 2022.</p>
      <p>Mr. Turley has extensive experience in Healthcare Capital Markets providing capital solutions to healthcare providers, investors, and developers in healthcare real estate, ranging from investment sales, monetization, development financing, and capital, and structured finance strategies. Most recently before joining Welltower, he served as Senior Managing Director at JLL where he served the firm’s clients interested in healthcare real estate.</p>
      <p>Mr. Turley earned a Bachelor of Science Degree in Urban Studies from Arizona State University a Master of Science Degree in Urban Planning from New York University.</p>
    </>,
  },
  {
    name: "Dan Bryan",
    img: Dan,
    title: "VP, FP&A – OM",
    bio: <>
      <p>Daniel Bryan serves as the Vice President of Financial Planning and Analysis, playing a key role at Welltower. In this capacity, he leads Asset Management, Financial Operations, and FP&A for the Outpatient Medical segment, contributing significantly to the company's financial strategy over his 8-year tenure. His areas of expertise include strategy implementation, portfolio value optimization, and precise budgeting.</p>
      <p>Before joining Welltower, Daniel Bryan was a Financial Analyst at the University of Toledo, where he refined the annual operating budget planning process, demonstrating his commitment to sound financial management.</p>
      <p>Daniel graduated magna cum laude with Bachelor of Business Administration with dual majors in Finance and Organizational Leadership & Management. He also holds an MBA with a focus on Operations Management and International Business, both earned from The University of Toledo.</p>
    </>,
  },
  {
    name: "Mark Kearns",
    img: Mark,
    title: "VP, Leasing",
    bio: <>
      <p>Mark Kearns is the VP, Leasing – Outpatient Medical at Welltower, Inc. In his role, he oversees all medical office leasing nationally and is responsible for creating the portfolio-wide leasing strategy to drive new and renewal leasing and deliver consistent NOI portfolio growth. Mr. Kearns joined Welltower in December 2022.</p>
      <p>Mark has extensive experience in nationwide development, leasing, and asset management for healthcare facilities and outpatient medical buildings and worked for such companies as Lend Lease and DASCO. Prior to joining Welltower, Mark was a Senior Director at Healthpeak overseeing the leasing of a nationwide portfolio of outpatient medical buildings.</p>
      <p>Mr. Kearns received his Bachelor of Science from Palm Beach Atlantic University.</p>
    </>,
  },
  {
    name: "Melanie Crozier",
    img: Melanie,
    title: "VP, Property Management",
    bio: <>
      <p>Melanie Crozier currently serves as the Vice President of Property Management at Welltower, Inc. In this pivotal role, she leads the property management team, ensuring best-in-class practices and operational alignment with the company's strategic direction. Melanie has been a dedicated member of the Welltower team for approximately fifteen years.</p>
      <p>Before joining Welltower, Melanie worked as a Property Manager with Rendina Healthcare Real Estate, where she gained valuable experience in the field.</p>
      <p>Melanie earned her MBA with honors from Texas Women's University and holds a bachelor's degree in Business Administration. In addition to her academic achievements, Melanie also earned her RPA (Real Property Administrator) credential from BOMA (Building Owners and Managers Association), an organization she maintains her affiliation with. Notably, in 2022-2023, Melanie served as the Chair of the BOMA Medical Office Committee for the Dallas Chapter, showcasing her dedication to industry excellence and leadership.</p>
    </>,
  },
  {
    name: "Ada Edwards",
    img: Ada,
    title: "VP, Property Management",
    bio: <>
      <p>Ada Edwards is currently the Vice President of Property Management at Welltower, where her tenure spans over a decade. In her capacity as Vice President, Ada plays a pivotal role in the oversight of real estate management teams within the Welltower's West portfolio. Her responsibilities encompass a wide spectrum, including optimizing property performance, enhancing tenant experiences, and ensuring the strategic management of valuable assets.</p>
      <p>Prior to joining Welltower, Ada held key roles in reputable organizations such as California Commercial Real Estate Services, Cushman & Wakefield of California, Inc., and Sabal Financial Group. Her experience spans diverse property types, including medical, office, and mixed-use real estate, as well as managing extensive portfolios.</p>
      <p>Ada Edwards is not only dedicated to her profession but also actively involved in her community. She volunteers as a financial literacy teacher for local non-profit organizations. Ada's educational background includes Business Administration and Organizational Leadership from the University of La Verne, complemented by her California Bureau of Real Estate Broker's license.</p>
    </>,
  },
  {
    name: "Rob Sauer",
    img: Rob,
    title: "VP, Maintenance & Construction",
    bio: <>
      <p>Robert Sauer is the VP, Maintenance and Construction - Outpatient Medical, where he has been an integral part of the team since June 2019. In his current capacity, Robert provides visionary leadership and strategic development for the Maintenance Operations and Tenant Improvement Construction Divisions. His responsibilities encompass a wide spectrum, including labor planning, material inventory management, project oversight, budget allocation, customer support, and the integration of cutting-edge technologies to optimize operational efficiency.</p>
      <p>With 27+ years' operations experience, Robert led Maintenance teams at Duke Realty in various divisions across the US. He later consulted for national commercial organizations and REITs. This diverse background enriches his approach at Welltower.</p>
      <p>Robert is an active member of BOMA, ASHRAE, and ASHE. He holds Technical, Safety, and HVAC Diplomas from respected institutions, plus BOMA, SMT, and LEED Green Associate credentials, showcasing his commitment to industry excellence.</p>
    </>,
  },
];

const About = () => {
  const [leaderPopup, setLeaderPopup] = useState(undefined);

  return (
      <>
        <Helmet>
          <title>Welltower Medical Office For Lease - Who We Are</title>
          <link rel="canonical" href={ absoluteUrl( "/who-we-are")} />
        </Helmet>
    <Box
      pt={"78px"}
      bgGradient="radial-gradient(36.09% 69.11% at 100% 33.15%, rgba(112, 207, 236, 0.48) 0%, rgba(116, 214, 241, 0) 100%)"
    >
      <Container maxW={{ lg: "40%", md: "60%" }}>
        <Box textAlign={"center"} mt={12}>
          <Heading
            mb={12}
            fontSize={{ xl: "5xl", base: "3xl" }}
            color={"DarkTeal"}
          >
            Real estate for a better healthcare experience
          </Heading>
        </Box>
      </Container>
      <Box
        mt={24}
        h={"472px"}
        bgImage={AboutBg}
        bgSize={"cover"}
        bgPos={"center right"}
      />
      <Box my={24}>
        <Container maxW={{ md: "80%", base: "100%" }}>
          <Grid
            gridTemplateColumns={{ lg: "repeat(2,1fr)", base: "repeat(1,1fr)" }}
            gap={12}
          >
            <GridItem>
              <Text
                color={"Teal"}
                fontSize={"4xl"}
                lineHeight={"3rem"}
                fontStyle={"italic"}
                fontWeight={"400"}
                letterSpacing={"-1.62px"}
              >
                Welltower delivers the healthcare infrastructure necessary to
                facilitate better health and wellness care.
              </Text>
            </GridItem>
            <GridItem>
              <Text color={"DarkBlue"} mt={16}>
                Our portfolio of medical office (Outpatient Medical) buildings
                is an integral part of creating health care provider
                connectivity in local markets. Outpatient medical solutions are
                growing due to the number of procedures that can be performed
                outside of hospitals. State-of-the-art outpatient centers are
                being built in accessible settings that are more consumer
                friendly.{" "}
              </Text>
              <Text color={"DarkBlue"} mt={8}>
                Welltower works diligently with our healthcare partners to
                ensure outpatient facilities are designed thoughtfully and
                strategically to enhance the consumer experience throughout the
                delivery of care. The health and safety of patients, visitors,
                and staff within facilities are Welltower’s primary focus, so
                Welltower deploys strict policies and procedures to ensure the
                highest quality settings possible.
              </Text>
            </GridItem>
          </Grid>
        </Container>
      </Box>
      <Box bgImage={LeadershipBg} bgSize={"cover"} py={24}>
        <Container maxW={{ md: "min(80%,1200px)", sm: "90%", base: "100%" }}>
          <Heading
            textAlign={"center"}
            fontSize={"5xl"}
            color={"BrightTurquoise"}
          >
            Outpatient Medical Leadership
          </Heading>
          <Flex
            pos={"relative"}
            mt={24}
            gap={12}
            flexWrap={"wrap"}
            justifyContent={"center"}
            sx={{
              ".chakra-collapse": {
                pos: "absolute",
                zIndex: 5,
                w: "100%",
                top: "50%",
                transform: "translateY(-50%)",
                left: "0px",
                right: "0px",
              },
              "@media screen and (max-width: 767px)": {
                ".chakra-collapse": {
                  top: "0%",
                  transform: "translateY(0%)",
                },
              },
            }}
          >
            {LeadersData.map((item) => {
              return (
                <>
                  <Box
                    pos={"relative"}
                    onClick={() => setLeaderPopup(item.name)}
                    key={item.name}
                    cursor={"pointer"}
                    w={{
                      lg: "calc(33% - 3rem)", // when we had 7, this was 25%-3rem which arranged 4+3 on desktop. With 6, that shows 4+2 which looks goofy, so change to 33%-3rem to get 3 columns
                      sm: "calc(50% - 3rem)",
                      base: "100%",
                    }}
                    maxWidth={"300px"} // Max size here and the container limits to 3 across. Maybe we need to rethink this layout. (maybe 2 or 3-col grids at breakpoints instead of flex?)
                  >
                    <Image src={item.img} alt={item.name} w={"100%"} />
                    <Text color={"white"} fontSize={"2xl"}>
                      {item.name}
                    </Text>
                    <Text color={"white"}>{item.title}</Text>
                  </Box>
                  <Collapse in={leaderPopup === item.name} animateOpacity>
                    <Flex
                      gap={6}
                      p={6}
                      borderRadius={"20px"}
                      border={"1px solid #E8E8E8"}
                      background={"#FFF"}
                      fontSize={"xs"}
                      display={{ lg: "flex", base: "block" }}
                    >
                      <CloseIcon
                        onClick={() => setLeaderPopup(undefined)}
                        pos={"absolute"}
                        w={{ lg: "6", base: "3" }}
                        h={{ lg: "6", base: "3" }}
                        right={4}
                        top={{ lg: "4", base: "2" }}
                        cursor={"pointer"}
                      />
                      <Box mx="auto" w={{ lg: "1300px", base: "100%" }}>
                        <Image src={item.img} w={"100%"} />
                      </Box>
                      <Box padding={"15px"}>
                        <Heading fontSize={"2xl"} color={"DarkTeal"}>
                          {item.name}
                        </Heading>
                        <Text mb={6} color={"DarkTeal"}>
                          {item.title}
                        </Text>
                        <Box
                          sx={{
                            p: {
                              color: "DarkBlue",
                              mb: 4,
                            },
                          }}>
                          {item.bio}
                        </Box>
                      </Box>
                    </Flex>
                  </Collapse>
                </>
              );
            })}
          </Flex>
        </Container>
      </Box>
      <Perspective bg="" />
    </Box>
        </>
  );
};

export default About;
